import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClicksMetricComponent } from './clicks-metrics/clicks-metric.component';

import { ClicksMetricService } from './clicks-metrics/clicks-metric.service';
import { IframeTrackClicksService } from './clicks-metrics/iframe-track-clicks.service';

@NgModule({
  imports: [CommonModule],
  declarations: [ClicksMetricComponent],
  exports: [ClicksMetricComponent],
  providers: [ClicksMetricService, IframeTrackClicksService],
})
export class MetricsModule {}
